RivalIQ.apps.Admin.apps.Account.module('views', function (views, App, Backbone, Marionette, $, _, async, moment, maxPostsToReturnDefault) {

    'use strict';

    function extendUiWithPlanOverrides(baseUi) {
        const planOverrideDefinitions = RivalIQ.enums.planOverrides.definitions;
        const dataTypes = RivalIQ.enums.planOverrides.dataTypes;

        const updatedUi = _.reduce(planOverrideDefinitions, function (ui, override) {
            let uiType;

            if (override.type === dataTypes.SELECTOR) {
                uiType = 'select';
            } else {
                uiType = 'input';
            }

            ui[override.uiElementName] = `${uiType}[name=${override.uiElementName}]`;

            return ui;
        }, baseUi);

        _.each(RivalIQ.enums.sourceMask, function (mask, name) {
            if (name !== 'ALL' && name !== 'DEFUNCT') {
                updatedUi[name] = `input[name=${name}]`;
            }
        });

        return updatedUi;
    }

    views.Edit = Marionette.ItemView.extend({
        template: '#accountEditTemplate',

        behaviors: {
            AttributeBuilder: {}
        },

        ui: extendUiWithPlanOverrides({
            email: 'input[name="email"]',
            group: 'select[name=group]',
            isLimitedWrapper: '.x-is-limited',
            paymentWrapper: '.x-payment-wrapper',
            payment: 'select[name=payment]',
            subscribedAtWrapper: '.x-subscribed-at-wrapper',
            subscribedAt: 'input[name="subscribed_at"]',
            accountEmailVerifiedAt: 'input[name="account_email_verified_at"]',
            churnedAtWrapper: '.x-churned-at-wrapper',
            churnedAt: 'input[name="churned_at"]',
            isSelfChurned: 'input[name="selfChurned"]',
            trialEndDate: 'input[name="trialendtime"]',
            enforceCompanyPlanLimit: 'input[name=enforceCompanyPlanLimit]',
            syncToIntercom: 'input[name=syncToIntercom]',
            plan: 'select[name=plan]',
            submitBtn: '.btn-primary.save',
            submitDeferEmailBtn: '.btn-default.save-defer-email',
            validationMessage: '.x-validation-msg',
            hasCompanionMode: 'input[name="hasCompanionMode"]',
            quidMonitorToken: 'input[name="quidMonitorToken"]'
        }),

        events: {
            'click @ui.submitBtn': 'save',
            'click @ui.submitDeferEmailBtn': 'saveDeferEmail',
            'input @ui.email': 'onEmailChange'
        },

        eventsNotToDebounce: {
            'change @ui.group': 'onGroupChange',
            'change @ui.payment': 'onPaymentChange',
            'change @ui.trialEndDate': 'onTrialEndDateChange',
            'change @ui.churnedAt': 'onChurnedAtChange',
            'change @ui.plan': 'onPlanChange',
            'change @ui.hasCompanionMode': 'onCompanionModeChange',
            'change @ui.quidMonitorToken': 'onCompanionModeChange'
        },

        templateHelpers: function () {
            const me = this;

            const selectorProperties = (me.getOption('selectorProperties') || {});
            const plans = _.reduce(_.get(selectorProperties, 'plans'), function (memo, plan) {
                memo[(plan.legacy ? 'legacy' : 'current')].unshift(plan);
                return memo;
            }, {
                legacy: [],
                current: []
            });

            const supportedSources = [];
            _.each(RivalIQ.enums.sourceMask, function (mask, name) {
                if (name !== 'ALL' && name !== 'DEFUNCT') {
                    supportedSources.push({
                        name: name,
                        mask: mask,
                        label: RivalIQ.enums.sourceDetails[mask].name
                    });
                }
            });
            supportedSources.sort(function (a, b) {
                return a.label.localeCompare(b.label);
            });

            const result = _.defaults({
                plans: plans,
                availableBetaFeatures: RivalIQ.availableBetaFeatures,
                accountUserStatuses: _.values(RivalIQ.enums.user.status),
                planOverrides: RivalIQ.enums.planOverrides,
                supportedSources: supportedSources
            }, _.omit(selectorProperties, 'plans'));
            return result;
        },

        serializeData: function () {
            const me = this;
            const data = me.model.toJSON();

            if (!data.account.subscribed_at) {
                data.subscribed_at_str = moment.utc().format('YYYY-MM-DD');
            } else {
                data.subscribed_at_str = moment.utc(data.account.subscribed_at).format('YYYY-MM-DD');
            }

            if (!data.account.churned_at) {
                data.churned_at_str = moment.utc().format('YYYY-MM-DD');
            } else {
                data.churned_at_str = moment.utc(data.account.churned_at).format('YYYY-MM-DD');
            }

            if (!data.account.account_email_verified_at) {
                data.account_email_verified_at_str = '';
            } else {
                data.account_email_verified_at_str = moment.utc(data.account.account_email_verified_at).format('YYYY-MM-DD');
            }

            return _.defaults({
                selfChurned: _.get(data, ['account', 'settings', 'selfChurned']),
                maxPostsToReturn: _.get(data, ['account', 'settings', 'maxPostsToReturn']),
                beta_features: (_.get(data, 'account.beta_features') || {}),
                syncToIntercom: !_.get(data, 'intercom_data.doNotSync', false),
                trialendtimestr: moment.utc(data.account.trial_end_at).format('YYYY-MM-DD'),
                plan_overrides: (_.get(data, 'account.plan_overrides') || {}),
                maxPostsToReturnDefault: maxPostsToReturnDefault
            }, data);
        },

        onRender: function () {
            const me = this;
            const account = me.model.get('account');

            me.$el.find('select[name="plan"]').val(account.plan_id);
            me.$el.find('select[name="group"]').val(account.account_group_id);
            me.$el.find('select[name="status"]').val(account.account_status_id);
            me.$el.find('select[name="payment"]').val(account.account_conversion_status_id);

            _.each(RivalIQ.enums.sourceMask, function (mask) {
                me.$el.find(`input[name="${mask}"]`).prop('checked', (account.plan_overrides.supported_sources & mask) > 0);
            });

            me.onGroupChange();
            me.onPaymentChange();
            me.onPlanChangeHelper();
            me.onEmailChange();
            me.onCompanionModeChange();
        },

        onPlanChange: function () {
            const me = this;
            const account = me.model.get('account');

            account.plan_overrides = {};
            account.enforce_company_plan_limit = true;
            me.ui.enforceCompanyPlanLimit.prop('checked', true);

            me.onPlanChangeHelper();
        },

        onPlanChangeHelper: function () {
            const me = this;
            const account = me.model.get('account');

            const selectorProperties = me.getOption('selectorProperties') || {};
            const plan = _.find(_.get(selectorProperties, 'plans'), {
                id: Number(me.$el.find('select[name="plan"]').val())
            });
            const planOverrides = account.plan_overrides;

            _.each(RivalIQ.enums.planOverrides.definitions, function (override) {
                const queryForUi = override.queryForUi || _.identity;
                const planValue = queryForUi(plan[override.planColumnName]);
                const overrideValue = queryForUi(_.get(planOverrides, override.planColumnName));
                const uiElement = me.ui[override.uiElementName];

                if (override.type === RivalIQ.enums.planOverrides.dataTypes.BOOLEAN) {
                    uiElement.prop('checked', planValue || Boolean(overrideValue));
                    uiElement.prop('disabled', planValue);
                }

                if (override.type === RivalIQ.enums.planOverrides.dataTypes.INTEGER) {
                    if (_.has(planOverrides, override.planColumnName)) {
                        uiElement.val(overrideValue);
                    } else {
                        uiElement.val('');
                        uiElement.prop('placeholder', `[use plan default: ${planValue}]`);

                        const minmax = me.getIntegerMinMax(plan, override);
                        uiElement.prop('disabled', minmax.min === minmax.max);
                    }
                }

                if (override.type === RivalIQ.enums.planOverrides.dataTypes.SELECTOR) {
                    uiElement.find('option[name="use_default"]').prop('label', `[use plan default: ${planValue}]`);
                    uiElement.val(overrideValue);
                }
            });

            const effectiveSources = plan.supported_sources | _.get(planOverrides, 'supported_sources', 0);
            _.each(RivalIQ.enums.sourceMask, function (mask, name) {
                if (name !== 'ALL' && name !== 'DEFUNCT') {
                    me.ui[name].prop('checked', (effectiveSources & mask) > 0);
                    me.ui[name].prop('disabled', (plan.supported_sources & mask) > 0);
                }
            });
        },

        onGroupChange: function () {
            const me = this;
            const ui = me.ui;
            const group = parseInt(ui.group.val());

            if (group === 1) {
                ui.isLimitedWrapper.show();
            } else {
                ui.isLimitedWrapper.hide();
            }

            if (group) {
                me.clearError('group');
                me.canSaveForm();
            } else {
                me.ui.submitBtn.toggleClass('disabled', true);
                me.ui.submitDeferEmailBtn.toggleClass('disabled', true);
                me.showErrorMessage('group', 'Group is required');
            }
        },

        onPaymentChange: function () {
            const me = this;
            const accountConversionStatusId = parseInt(me.ui.payment.val());

            // trial === 1
            if (accountConversionStatusId !== 1) {
                me.ui.subscribedAtWrapper.show();
            } else {
                me.ui.subscribedAtWrapper.hide();
            }

            // churned === 4
            if (accountConversionStatusId === 4) {
                me.ui.churnedAtWrapper.show();
                me.onChurnedAtChange();
            } else {
                me.ui.churnedAtWrapper.hide();
            }

            if (accountConversionStatusId) {
                me.clearError('payment');
                me.canSaveForm();
            } else {
                me.ui.submitBtn.toggleClass('disabled', true);
                me.ui.submitDeferEmailBtn.toggleClass('disabled', true);
                me.showErrorMessage('payment', 'Payment is required');
            }
        },

        onEmailChange: function () {
            const me = this;
            const email = me.ui.email.val();

            if (RivalIQ.utils.email.validEmailAddress(email)) {
                me.clearError('email');
                me.canSaveForm();
            } else {
                me.ui.submitBtn.toggleClass('disabled', true);
                me.ui.submitDeferEmailBtn.toggleClass('disabled', true);
                me.showErrorMessage('email', 'Email is required');
            }
        },

        onCompanionModeChange: function () {
            const me = this;
            const hasCompanionMode = me.ui.hasCompanionMode.prop('checked');
            const quidMonitorToken = me.ui.quidMonitorToken.val();

            if (hasCompanionMode && quidMonitorToken === '') {
                me.ui.submitBtn.toggleClass('disabled', true);
                me.ui.submitDeferEmailBtn.toggleClass('disabled', true);
                me.showErrorMessage('quidMonitorToken', 'Token is required');
            } else {
                me.clearError('quidMonitorToken');
                me.canSaveForm();
            }
        },

        canSaveForm: function () {
            const me = this;
            if (me.$('.form-group.has-error').length === 0) {
                me.ui.submitBtn.toggleClass('disabled', false);
                me.ui.submitDeferEmailBtn.toggleClass('disabled', false);
            }
        },

        showErrorMessage: function (field, message) {
            const me = this;
            const input = me.$(`[name="${field}"]`);
            const formGroup = input.closest('.form-group');
            formGroup.addClass('has-error');
            formGroup.find('.x-validation-msg').html(message).show();
        },

        clearError: function (field) {
            const me = this;
            const input = me.$(`[name="${field}"]`);
            const formGroup = input.closest('.form-group');
            formGroup.removeClass('has-error');
            formGroup.find('.x-validation-msg').hide();
        },

        saveDeferEmail: function () {
            const me = this;
            me.options.sendWelcomeEmail = false;
            me.save();
        },

        save: function () {
            const me = this;
            const adminCreated = me.getOption('model').getAccount().get('admin_created');

            if (!me.validateInputFields()) {
                return;
            }

            const refreshAfterSave = me.getOption('refreshAfterSave');
            me.ui.submitBtn.button('loading');

            const trigger = adminCreated ? 'account:create:complete' : 'account:edit:complete';

            const deferred = async.callbackToDeferred(function (error, result) {
                App.trigger(trigger, me.model);

                if (error) {
                    me.ui.submitBtn.button('reset');

                    if (!adminCreated) {
                        me.$el.find('.modal').modal('hide');
                    }

                    return RivalIQ.execute('alert:error', error);
                }

                me.model.set(result, {
                    silent: true
                });
                me.$el.find('.modal').modal('hide');
                RivalIQ.execute('alert:info', 'Account saved');

                if (refreshAfterSave) {
                    window.location.reload();
                }
            });

            me.model.save(me.serialize()).done(deferred.resolve).fail(deferred.reject);
        },

        serialize: function () {
            const me = this;
            const accountConversionStatusId = parseInt(me.ui.payment.val());
            const planId = Number(me.$('select[name="plan"]').val());
            const selectorProperties = me.getOption('selectorProperties') || {};
            const plan = _.find(_.get(selectorProperties, 'plans'), {
                id: planId
            });

            const betaFeatures = {};
            _.each(me.$('input[data-beta-feature="true"]'), function (input) {
                const $input = $(input);
                const name = $input.attr('name');
                betaFeatures[name] = $input.is(':checked');
            });

            const planOverrideDefinitions = RivalIQ.enums.planOverrides.definitions;

            const planOverrides = _.reduce(planOverrideDefinitions, function (newPlanOverrides, override) {
                const element = me.ui[override.uiElementName];
                const value = override.prepare(element);

                if (element.val() === '' || value === plan[override.planColumnName] || value === null) {
                    delete newPlanOverrides[override.planColumnName];
                } else {
                    newPlanOverrides[override.planColumnName] = value;
                }

                return newPlanOverrides;
            }, me.model.get('account').plan_overrides || {});

            let supported_sources = _.reduce(me.$('input[data-supported-sources="true"]'), function (memo, input) {
                const $input = $(input);

                if ($input.is(':checked')) {
                    memo = memo | RivalIQ.enums.sourceMask[$input.attr('name')];
                }

                return memo;
            }, 0);
            supported_sources &= ~plan.supported_sources;

            if (supported_sources) {
                planOverrides.supported_sources = supported_sources;
            } else {
                delete planOverrides.supported_sources;
            }

            // TODO: filter plan_overrides, remove redundant (re plan values)
            const results = {
                first_name: $.trim(me.$('input[name="firstname"]').val()) || null,
                last_name: $.trim(me.$('input[name="lastname"]').val()) || null,
                email: $.trim(me.$('input[name="email"]').val()) || null,
                account_user_status_id: Number(me.$('select[name="account_user_status_id"]').val()),
                account: {
                    trial_end_at: me.trialEndTime,
                    plan_id: planId,
                    stripe_coupon: $.trim(me.$('input[name="stripecoupon"]').val()) || null,
                    hubspot_hub_id: $.trim(me.$('input[name="hubspotHubId"]').val()) || null,
                    parent_account_id: Number($.trim(me.$('input[name="parentAccountId"]').val())) || null,
                    primary_account_id: Number($.trim(me.$('input[name="primaryAccountId"]').val())) || null,
                    has_companion_mode: me.$('input[name="hasCompanionMode"]').is(':checked'),
                    quid_monitor_token: $.trim(me.$('input[name="quidMonitorToken"]').val()) || null,
                    account_group_id: Number(me.$('select[name="group"]').val()),
                    account_status_id: Number(me.$('select[name="status"]').val()),
                    account_conversion_status_id: Number(me.$('select[name="payment"]').val()),
                    enabled: me.$('input[name="enabled"]').is(':checked'),
                    is_payment_overdue: me.$('input[name="isPaymentOverdue"]').is(':checked'),
                    is_agency: me.$('input[name="isAgency"]').is(':checked'),
                    show_payment_overdue_warning: me.$('input[name="showPaymentOverdueWarning"]').is(':checked'),
                    subscribed_at: (accountConversionStatusId !== 1 ? me.ui.subscribedAt.val() : null),
                    account_email_verified_at: me.ui.accountEmailVerifiedAt.val() || null,
                    churned_at: (accountConversionStatusId === 4 ? me.churnedAtTime : null),
                    beta_features: betaFeatures,
                    trial_report_limit: (parseInt(me.$('input[name="trialReportLimit"]').val()) || null),
                    enforce_company_plan_limit: me.ui.enforceCompanyPlanLimit.is(':checked'),
                    version: me.model.get('account').version,
                    payment_via_invoice: $('input[name="payment_via_invoice"]').is(':checked'),
                    hide_insights_on_export: $('input[name="hide_insights_on_export"]').is(':checked'),
                    tax_exempt: $('input[name="tax_exempt"]').is(':checked'),
                    zip_code: $.trim(me.$('input[name="zipCode"]').val()) || null,
                    plan_overrides: planOverrides,
                    admin_created: me.model.get('account').admin_created
                }
            };

            const data = me.model.toJSON();

            const settings = data.account.settings;

            settings.selfChurned = me.ui.isSelfChurned.is(':checked');

            const maxPostsToReturn = (parseInt(me.$('input[name="maxPostsToReturn"]').val()) || null);
            if (maxPostsToReturn) {
                settings.maxPostsToReturn = maxPostsToReturn;
            } else {
                delete settings.maxPostsToReturn;
            }

            results.account.settings = settings;

            // For intercom, maintain intercom_data and only change the sync state
            // (some of the intercom_data fields must be maintained for continuity).
            results.intercom_data = data.intercom_data || {};
            results.intercom_data.doNotSync = !me.ui.syncToIntercom.is(':checked');
            results.admin_created = me.model.get('account').admin_created;
            results.sendWelcomeEmail = me.options.sendWelcomeEmail;
            return results;
        },

        // preserve original trial end time so we don't rob people of hours
        onTrialEndDateChange: function () {
            const me = this;
            const newDate = moment.utc(me.ui.trialEndDate.val());
            const oldDate = moment.utc(me.model.get('account').trial_end_at);

            me.trialEndTime = newDate
                .hours(oldDate.hours())
                .minutes(oldDate.minutes())
                .seconds(oldDate.seconds())
                .format();
        },

        // give people until the end of the (UTC) day that they churn
        onChurnedAtChange: function () {
            const me = this;
            const newDate = moment.utc(me.ui.churnedAt.val());

            me.churnedAtTime = newDate
                .hours(23)
                .minutes(59)
                .seconds(59)
                .format();
        },

        getIntegerMinMax: function (plan, override) {
            const fromPlan = plan[override.planColumnName];
            const minmax = {
                min: override.min,
                max: override.max
            };

            if (minmax.min === RivalIQ.enums.planOverrides.constants.usePlanValue) {
                minmax.min = fromPlan;
            }

            if (minmax.max === RivalIQ.enums.planOverrides.constants.usePlanValue) {
                minmax.max = fromPlan;
            }

            return minmax;
        },

        validateInputFields: function () {
            const me = this;

            const selectorProperties = (me.getOption('selectorProperties') || {});
            const plan = _.find(_.get(selectorProperties, 'plans'), {
                id: Number(me.$el.find('select[name="plan"]').val())
            });
            const dataTypes = RivalIQ.enums.planOverrides.dataTypes;
            let allFieldsValid = true; // until proven otherwise

            _.each(RivalIQ.enums.planOverrides.definitions, function (override) {
                // For now we only care about integer input fields.
                if (override.type !== dataTypes.INTEGER) {
                    return;
                }

                const element = me.ui[override.uiElementName];
                let fieldValid = true;
                let invalidMessage;

                if (element.val() !== '') {
                    const value = override.prepare(element);

                    // Chase down the min/max range allowed, complicated somewhat by "usePlanValue".
                    const minmax = me.getIntegerMinMax(plan, override);

                    // Validate it.
                    if (_.isFinite(value)) {
                        if (value < minmax.min) {
                            if (value !== 0 || (value === 0 && !override.allowZero)) {
                                fieldValid = false;
                            }
                        }

                        if (value > minmax.max) {
                            fieldValid = false;
                        }
                    } else {
                        fieldValid = false;
                    }

                    invalidMessage = `${override.uiLabel} must be `;
                    if (override.allowZero) {
                        invalidMessage += ' 0 or ';
                    }
                    if (minmax.min === minmax.max) {
                        invalidMessage += minmax.min;
                    } else {
                        invalidMessage += `between ${minmax.min} and ${minmax.max}`;
                    }
                }

                // Update the UI to reflect the validation.
                const formGroup = element.closest('.form-group');
                const helpBlock = formGroup.find('.help-block');

                if (fieldValid) {
                    formGroup.removeClass('has-error');
                    helpBlock.text('');
                    helpBlock.toggleClass('display-none', true);
                } else {
                    formGroup.addClass('has-error');
                    helpBlock.text(invalidMessage);
                    helpBlock.toggleClass('display-none', false);

                    if (allFieldsValid) {
                        // Set input focus to first invalid field.
                        formGroup.find('input').focus();
                        allFieldsValid = false;
                    }
                }
            });

            return allFieldsValid;
        }
    });

}, RivalIQ.utils.async, window.moment, window.maxPostsToReturnDefault);
